import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useSWRImmutable from 'swr/immutable';
import { useTranslation } from 'react-i18next';

import OrderDetailsMetadata from 'components/Account/MyOrder/OrderDetails/OrderDetailsMetadata';
import { default as OrderDetailsComponent } from 'components/Account/MyOrder/OrderDetails/OrderDetails';
import Loader from 'components/Common/Loader/Loader';
import { FLASH_MESSAGE_STATE_KEY } from 'contexts/flashMessageContext';
import { FetchError } from 'exceptions/FetchError';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { apiUrls } from 'services/api-urls';
import { fetcher } from 'services/fetcher';
import { getRoutesUri } from 'services/generic';
import { GTM_PAGE_ACCOUNT } from 'settings/gtm/gtmPageView';
import { DataDetailsOrder } from 'types/DetailsProducts';

export default function OrderDetails(): JSX.Element | null {
  const { id: idOrder } = useParams<{ id: string }>();
  const { t } = useTranslation('ordersPage');
  const navigate = useNavigate();
  const { data: order, error } = useSWRImmutable<DataDetailsOrder, FetchError>(
    idOrder ? apiUrls.getCustomerOrderDetails(idOrder) : null,
    fetcher
  );

  useGtmPageView(GTM_PAGE_ACCOUNT, '');

  function handleError(messageKey: string) {
    navigate(getRoutesUri<string>('customerAccountOrderHistory'), {
      state: {
        [FLASH_MESSAGE_STATE_KEY]: {
          message: t(messageKey),
          severity: 'error',
        },
      },
    });
  }

  if (error) {
    handleError(
      error.status === 404
        ? 'ORDER_DETAIL_ERROR_MESSAGE_NOT_FOUND'
        : 'ORDER_DETAIL_ERROR_MESSAGE_UNKNOWN'
    );

    return null;
  }

  if (!order) return <Loader />;

  return (
    <>
      <OrderDetailsMetadata />
      <OrderDetailsComponent order={order} />
    </>
  );
}
